import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { User } from '@app/_models';
import { UserService, AuthenticationService, AlertService } from '@app/_services';
import { Router } from '@angular/router';
import { SelectItem, LazyLoadEvent } from 'primeng/api';

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.css'],
    standalone: false
})
export class UserListComponent implements OnInit
{
	datasource: User[];
	user: User;
	users: User[] = [];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	userStatusOptions: SelectItem[];



	constructor(
		private authenticationService: AuthenticationService,
		private userService: UserService,
		private alertService: AlertService,
		private router: Router
	) { }


	ngOnInit()
	{
		try
		{
			this.userStatusOptions = [
				{ label: 'Active', value: 'A' },
				{ label: 'Suspended', value: 'S' },
				{ label: 'Canceled', value: 'C' }
			];

		} catch (error)
		{
			console.log('ngOnInit() ' + error);
		}
	}

	loadLazy(event: LazyLoadEvent)
	{
		try
		{
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			const pageNumber = Math.round(event.first / event.rows);
			this.userService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					apiResponse =>
					{
						// console.log('users are: ' + JSON.stringify(apiResponse));
						this.datasource = apiResponse.data.users;
						this.recordTotal = apiResponse.page.recordTotal;
						this.users = apiResponse.data.users;
					},
					apiResponse =>
					{
						console.log('USER LIST!: ' + JSON.stringify(apiResponse));
						this.alertService.error(apiResponse);
					},
					() =>
					{ this.loading = false; }
				);

			if (this.datasource)
			{
				this.users = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error)
		{
			console.log('loadLazy(' + event + ')' + error);
		}
	}
	onRowSelect(event)
	{
		try
		{
			// use this for adding query params
			// this.router.navigate(['user-edit'], { queryParams: { userId: event.data.userId } });
			this.router.navigate(['user-view', event.data.userId]);
		} catch (error)
		{
			console.log('onRowSelect(' + event + ')' + error);
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
